import { z } from 'zod'

export default z.object({
  __typename: z.literal('PersonAddress').default('PersonAddress'),
  id: z.string(),
})
